// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue/dist/vue.esm'
import App from './App'
import router from './router'
import Axios from 'axios';
import { store } from './store/store';
import VuexFlash from 'vuex-flash';
import ColourPicker from 'vue-colour-picker';
import Skeleton from 'vue-loading-skeleton';

Vue.prototype.$logoName = '';
Vue.prototype.$isBranding = '';
Vue.prototype.$whiteFlag = '';
Vue.prototype.$managerPathwayFeature = '';
Vue.prototype.$myPathwayFlag = '';

Vue.use(Skeleton)

Vue.use(VuexFlash, { mixin: true, keep: false });

Vue.config.productionTip = false

Axios.defaults.baseURL = process.env.API_ENDPOINT;
Axios.defaults.headers.post['Access-Control-Allow-Origin'] = process.env.API_ENDPOINT;
Axios.defaults.headers.post['Access-Control-Allow-Headers'] = 'Origin', 'Content-Type', 'Access-Control-Allow-Origin', 'Access-Control-Allow-Headers', 'Authorization';
Axios.defaults.headers.post['Accept'] = 'application/json';
Axios.defaults.headers.post['Content-Type'] = 'application/json';

Axios.interceptors.request.use(
  function (config) {
    let token = store.state.token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${ token }`;
    }
    else {
      config.headers['Authorization'] = `Bearer`;
    }
    let switch_admin_username = store.state.switch_admin_username;
    if (switch_admin_username) {
      config.headers['x-switch-user'] = `${ switch_admin_username }`;
    }
    else {
      config.headers['x-switch-user'] = ``;
    }
    return config;
  },
);

Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const { config, response: { status } } = error;
    var error_message = error.response.data.message;
    var error_code = error.response.data.code;
    if((error_message == 'Expired JWT Token') && (error_code == 401)) {
      let refresh_token = store.state.refresh_token;
      document.getElementById("refresh_token_retry").style.display = 'block';
      return Axios.post('/api/token/refresh', {
        refresh_token: refresh_token
      })
      .then(response => {
        document.getElementById("refresh_token_retry").style.display = 'none';
        let refresh_token = response.data.refresh_token;
        let token = response.data.token;
        store.dispatch('refresh_token', { refresh_token, token })
        error.config.headers['Authorization'] = 'Bearer ' + token;
        return Axios.request(error.config);
      }).catch(error => {
        document.getElementById("refresh_token_retry").style.display = 'none';
        store.dispatch('logout');
        let msg = 'Session expired. Please login.';
        let status = 'danger';
        store.dispatch('set_flash_msg', { msg, status})
        router.push('/login');
      })
    }
    else if((error_message == 'Access denied.') && (error_code == 403)) {
      router.push('/forbidden');
    }
    else {
      return Promise.reject(error);
    }
  }
);

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/styles/style.css';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});




// WEBPACK FOOTER //
// ./src/main.js